import axios from "@/api/axiosInstance";
import {
  UpdateEmployeeProfileRequest,
  UpdateEmployeeProfileResponse,
} from "./types";

export const updateEmployeeProfile = async (
  uuid: string,
  requestData: UpdateEmployeeProfileRequest,
): Promise<UpdateEmployeeProfileResponse> => {
  const response = await axios.put<UpdateEmployeeProfileResponse>(
    `/api/private/employee-directory/profiles/${uuid}`,
    requestData,
  );
  return response.data;
};
